import React from "react";
import "./skills.css";
import fE from "../../assets/Vector.png";
import bE from "../../assets/Group 1456.png";
import mL from "../../assets/Ellipse 6.png";

const Skills = () => {
  return (
    <section id="skills">
      <span className="skillTile">My areas of focus</span>
      <div className="skillBars">
        <div className="skillBar">
          {/* <img src={fE} alt="" className="skillImg" /> */}

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="108"
            height="108"
            viewBox="0 0 108 108"
            fill="none"
          >
            <path
              d="M0.452515 47.9696H107.547V59.1253H0.452515V47.9696Z"
              fill="#6562F5"
            />
            <path
              d="M59.5778 4.87632e-07L59.5778 107.095H48.4221L48.4221 0L59.5778 4.87632e-07Z"
              fill="#6562F5"
            />
            <path
              d="M95.8077 19.6279L20.0802 95.3554L12.1919 87.4671L87.9195 11.7396L95.8077 19.6279Z"
              fill="#6562F5"
            />
            <path
              d="M87.9195 95.3555L12.192 19.628L20.0802 11.7397L95.8078 87.4672L87.9195 95.3555Z"
              fill="#6562F5"
            />
          </svg>

          <div className="skillBarText">
            <h2 className="skillDesc">Front end</h2>
            <p className="skillBarP">
              I'm deeply passionate about crafting user experiences that truly
              delight. From creating sleek and responsive designs using HTML,
              CSS, and JavaScript to mastering modern frameworks like React, I
              thrive in transforming visions into interactive realities.
            </p>
          </div>
        </div>
        <div className="skillBar">
          {/* <img src={bE} alt="" className="skillImg" /> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="110"
            height="110"
            viewBox="0 0 110 110"
            fill="none"
          >
            <rect
              width="55.2709"
              height="55.8128"
              transform="matrix(-1 0 0 1 110 0)"
              fill="#CADD57"
            />
            <rect
              width="55.8128"
              height="55.8128"
              transform="matrix(-1 0 0 1 55.8129 54.1872)"
              fill="#CADD57"
            />
          </svg>
          <div className="skillBarText">
            <h2 className="skillDesc">Back end</h2>
            <p className="skillBarP">
              Using the MERN stack, I shape web apps' back-end. With Node.js
              expertise, I ensure scalable servers and smooth data transfers. My
              skills in MongoDB optimize data management, while Express.js
              streamlines API development.
            </p>
          </div>
        </div>
        <div className="skillBar">
          {/* <img src={mL} alt="" className="skillImg" /> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="161"
            height="81"
            viewBox="0 0 161 81"
            fill="none"
          >
            <path
              d="M160.151 80.0755C160.151 69.5599 158.08 59.1472 154.056 49.4319C150.032 39.7167 144.133 30.8893 136.697 23.4536C129.262 16.0179 120.434 10.1196 110.719 6.09539C101.004 2.07121 90.5912 -4.59654e-07 80.0755 0C69.5599 4.59655e-07 59.1472 2.07122 49.4319 6.09539C39.7167 10.1196 30.8893 16.0179 23.4536 23.4536C16.0179 30.8893 10.1196 39.7167 6.09538 49.432C2.07121 59.1472 -9.19309e-07 69.5599 0 80.0755L80.0755 80.0755H160.151Z"
              fill="#E0DDD6"
            />
          </svg>
          <div className="skillBarText">
            <h2 className="skillDesc t">Machine learning</h2>
            <h2 className="skillDesc tM">ML</h2>
            <p className="skillBarP">
              When it comes to machine learning, I excel at building and
              training models for various tasks, from image classification to
              natural language processing. My skills include data preprocessing,
              model selection, and evaluation, as well as deploying machine
              learning solutions in production environments.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
